/**
 * <ss-reveal> — the drag-it-yourself before/after wipe.
 *
 * The whole control is a single range input stretched over the media, so the
 * interaction is a native slider: it drags with a mouse, works under a finger,
 * takes arrow keys and Home/End, and announces itself to a screen reader
 * without any of that being reimplemented. All this element does is mirror the
 * input's value onto a custom property that the CSS clips the "after" layer with.
 */
class SSReveal extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="range"]');
    if (!this.input) return;

    this.onInput = this.onInput.bind(this);
    this.input.addEventListener('input', this.onInput);
    this.onInput();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
  }

  onInput() {
    const value = Number(this.input.value);
    if (Number.isNaN(value)) return;
    this.style.setProperty('--ss-reveal', `${value}%`);
  }
}

if (!customElements.get('ss-reveal')) {
  customElements.define('ss-reveal', SSReveal);
}
